import { render } from "./SingleDeletionModal.vue?vue&type=template&id=6acca858"
import script from "./SingleDeletionModal.vue?vue&type=script&lang=js"
export * from "./SingleDeletionModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__